import { Typography } from '@components/atoms/Typography/Typography'

interface LoadingStateProps {
  message?: string
}

export function LoadingState({ message = 'Chargement...' }: LoadingStateProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center text-foreground">
        <Typography type="body" size="md">
          {message}
        </Typography>
      </div>
    </div>
  )
}
